class PacksCore {
  constructor() {
    
    
  } 
  setUrlByColor(color,size) {
    
    const urlParams = new URLSearchParams(window.location.search);
    if (size == 1) {
      urlParams.delete('bundle');
      urlParams.delete('color');
    }else {
      urlParams.delete('variant');
      urlParams.set('bundle', `pack-${size}`);
      urlParams.set('color', color);
    }
    const newUrl = window.location.origin + window.location.pathname + '?' + urlParams.toString();
    window.history.replaceState({}, document.title, newUrl);
  }
  async evaluateIntelligems(callback) {
    return new Promise((resolve) => {
      // First check if igData and user already exist
      if (window.igData && window.igData.user) {
        callback();
        resolve(true);
        return;
      }

      // If not, listen for the event
      
      window.addEventListener("ig:ready", () => {
        // Double check that igData.user exists after the event
        if (window.igData && window.igData.user) {
          callback();
          resolve(true);
        }
      });
    });
  }
  overWriteDiscount = async (packSize, discount, item,forceAbTest = null,fit) => {
    
    let label = document.querySelector(`label[for="pack-${packSize}"].pack-size`);
    if (!label) return;

    const abTestAtribute = label.getAttribute('ab-test');

    if (abTestAtribute && abTestAtribute.includes(fit)) return; 

    let packsInput = document.querySelector(`#pack-${packSize}`);
    if (packsInput) packsInput.setAttribute('discount', discount);
    if (forceAbTest) {
      if (abTestAtribute) {
        label.setAttribute('ab-test', abTestAtribute + '.' + fit);
      } else {
        label.setAttribute('ab-test', fit);
      }
    }
    let savingsLabel = label.querySelector('.savings:not(.convert_each)'); // not convert each
    let savingsLabel2 = label.querySelector('.savings.convert_each '); // convert each
    let savingsLabel3 = label.querySelector('.savings.save-money '); // save $xx money amount

    let priceItem = label.querySelector(".price");
    let priceFinal = label.querySelector(".price-final");
    let priceDiscount = label.querySelector(".price-discount");

    let priceTotal = 0;
    const firstVariant = item.variants[0].id;
    
    if (window.igData.price) {
      const igPrice = window.igData.price.getPriceByVariantId(firstVariant) * 100;
      if (igPrice) {
        priceTotal = igPrice * packSize;
      } else {
        priceTotal = (item.price * packSize);
      } 
    } else {
      await this.evaluateIntelligems(() => {
        return this.overWriteDiscount(packSize, discount, item, forceAbTest, fit);
      }); 
      return;
    }
    
    let priceTotalDiscount = (priceTotal - (priceTotal * (discount / 100))) / 100;
    
    if (savingsLabel) savingsLabel.innerHTML = ` ${window.theme.save_text} ${discount}% `;

    if (savingsLabel2) {
      const unitPrice = Math.ceil(priceTotal / packSize);
      const unitPriceDiscount = Math.ceil(priceTotalDiscount / packSize);
      

      savingsLabel2.innerHTML = `<span data-unit="${packSize}">${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(unitPriceDiscount)}</span> each`;
    }

    if (savingsLabel3) {

      const moneySaved = Math.ceil((priceTotal / 100) - priceTotalDiscount);
      savingsLabel3.innerHTML = `${window.theme.save_text} ${window.theme.cart_currency_symbol}${moneySaved} `;
    }

    priceFinal.innerHTML = window.theme.cart_currency_symbol + Shopify.formatMoneyAmmount(priceTotalDiscount);
    priceDiscount.innerHTML = window.theme.cart_currency_symbol + Shopify.formatMoneyAmmount((priceTotal / 100));

  }
  
  async updateIntelligencePrices() {
    if (window.igData && window.igData.price) {
      document.querySelectorAll(".variant__size").forEach((item) => {
        const intelligencePrice = window.igData.price.getPriceByVariantId(
          item.id
        );

        if (intelligencePrice) {
          item.setAttribute("price", intelligencePrice * 100);
        }
      });
    }
    return true;
  }
 
  
  applyIntelligemsTest = async (testId, fit, versionsArray, product) => {
    // First check if igData exists and has required properties
    if (!window.igData || !window.igData.user) {
      console.log('Intelligems not fully loaded, attempting to evaluate...');
      try {
        await this.evaluateIntelligems(() => {

          return this.applyIntelligemsTest(testId, fit, versionsArray, product);
        });
        
      } catch (error) {
        console.error('Failed to evaluate Intelligems:', error);
        return false;
      }
    }

    try {
      const testObject = window.igData.user.getTestGroup(testId);
      if (!testObject) {
        console.log(`No test group found for testId: ${testId}`);
        return false;
      }

      const { name, isControl } = testObject;

      // Handle control version
      if (isControl) {
     
        const versionControl = versionsArray.find(version => version.name === "control") || versionsArray[0];
        if (!versionControl) {
          console.log('Control version not found in versions array');
          return false;
        }
        for (const discount of versionControl.discounts) {
          this.overWriteDiscount(discount['pack-size'], discount.discount, product, null, fit);
        }
        return true;
      }

      // Handle test version
      const version = versionsArray.find(version => name.includes(version.name));
      if (!version) {
        console.log(`No matching version found for test name: ${name}`);
        return false;
      }

      
      for (const discount of version.discounts) {
        this.overWriteDiscount(discount['pack-size'], discount.discount, product, null, fit);
      }
      return true;

    } catch (error) {
      console.error('Error applying Intelligems test:', error);
      return false;
    }
  }
  findFit(tags) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].includes("fit_")) {
        return tags[i].split("fit_")[1].toLowerCase();
      }
    }

    return null;
  }
  findFabric(tags) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].includes("fabric_")) {
        return tags[i].split("fabric_")[1].toLowerCase();
      }
    }
  }

  findColor(tags) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].includes("color_")) {
        return tags[i].split("color_")[1].toLowerCase();
      }
    }

    return null;
  }

  findProductColor(product) {
    if (product.options[0].values[0]) {
      return product.options[0].values[0];
    }
    return null;
  }

}

// Attach the class to the window object
window.PacksCore = new PacksCore;


class JeanPackSize extends HTMLElement {
  constructor() {
    super();
    this.waistListener();
    this.inseamListener();
    this.atcBtn = document.querySelector(".multiple-add-to-cart");

    this.productPack = document.querySelector("product-pack");
    this.defaultSelected = {
      waist: null,
      inseam: null
    }
    this.altdescriptionTab = document.querySelector("alt-description-tab");
  }
  async setSelectedPackAndColor(packSize) {
    this.packSize = packSize;
    const selectedFit = document.querySelector(".product-fit__choice.fit-active").getAttribute("data-fit");
    console.log('fit', selectedFit);
    const colorSetWrapper = document.querySelector(`.color-set__wrapper.color_picker-colors[pack-size="${packSize}"][fit="${selectedFit}"]`);
    console.log(colorSetWrapper);
    if (colorSetWrapper) {
      const colorsInput = [...colorSetWrapper.querySelectorAll('.color_picker-colors-container input')];
      if (colorsInput && colorsInput[0]) {
        let color = colorsInput[0];
        console.log('colores Cesar', colorsInput);
        await this.setSelectedColorSet(color).then(() => {
          return;
        });

      }
      return;


    }
  }
  setDefaultSelectedWaistAndInseam() {

    if (this.defaultSelected.waist || this.defaultSelected.inseam) {
      const waistInput = this.querySelector(`.product-form__input[data-option-name="Waist"] input[value="${this.defaultSelected.waist}"]`);
      if (waistInput) {
        waistInput.checked = true;
        this.setSelectedWaist(waistInput);
      }
      const inseamInput = this.querySelector(`.product-form__input[data-option-name="Inseam"] input[value="${this.defaultSelected.inseam}"]`);
      if (inseamInput) {
        inseamInput.checked = true;
        this.setSelectedInseam(inseamInput);
      }
      this.evaluateInseamAndWaistSelected();
      return;
    }

    const waistSelectedInput = [...document.querySelectorAll(`variant-radios fieldset[data-option-name="Waist"] input`)].map(input => {
      if (input.checked) return input;
    }).filter(input => input != undefined)[0];

    if (waistSelectedInput) {
      const waistInput = this.querySelector(`.product-form__input[data-option-name="Waist"] input[value="${waistSelectedInput.value}"]`);
      if (waistInput) {
        waistInput.checked = true;
        this.setSelectedWaist(waistInput);
      }
      this.defaultSelected.waist = waistSelectedInput.value;
    }

    const inseamSelectedInput = [...document.querySelectorAll(`variant-radios fieldset[data-option-name="Inseam"] input`)].map(input => {
      if (input.checked) return input;
    }).filter(input => input != undefined)[0];
    if (inseamSelectedInput) {
      const inseamInput = this.querySelector(`.product-form__input[data-option-name="Inseam"] input[value="${inseamSelectedInput.value}"]`);
      if (inseamInput) {
        inseamInput.checked = true;
        this.setSelectedInseam(inseamInput);
      }
      this.defaultSelected.inseam = inseamSelectedInput.value;
    }

    this.evaluateInseamAndWaistSelected();

  }

  setSelectedInseam(inseamInput) {
    const waistInputs = this.querySelectorAll('.product-form__input[data-option-name="Waist"] input');
    waistInputs.forEach(waistInput => {
      waistInput.disabled = false;
      waistInput.parentElement.classList.remove('disabled');
    });

    const selectedInseam = inseamInput.value;
    this.defaultSelected.inseam = selectedInseam;

    console.log('products', this.products);

    const variantsWithThisInseam = this.products.map(product => {
      return product.variants.filter(variant => {
        return variant.inseam == selectedInseam;
      });
    });

    const waistsToDisable = [];
    const waistsExist = [];

    this.waistOptions.forEach(waist => {
      variantsWithThisInseam.forEach(product => {
        product.forEach(variant => {
          if (variant.waist == waist && !waistsExist.includes(waist)) {
            waistsExist.push(waist);
          } else if (variant.waist == waist && variant.quantity < variant.itemQty) {     // consultar con Cesar si lo valido por exactamente la cantidad de item o al menos le sumo 1 o 2 items
            waistsToDisable.push(waist);
          }
        });
      });
    });

    this.waistOptions.forEach(waist => {
      if (!waistsExist.includes(waist) && !waistsToDisable.includes(waist)) {
        waistsToDisable.push(waist);
      }
    });

    waistsToDisable.forEach(waist => {
      const waistInput = this.querySelector(`.product-form__input[data-option-name="Waist"] input[value="${waist}"]`);
      waistInput.disabled = true;
      waistInput.parentElement.classList.add('disabled');
    });



  }
  setSelectedWaist(waistInput) {
    const inseamInputs = this.querySelectorAll('.product-form__input[data-option-name="Inseam"] input');
    inseamInputs.forEach(inseamInput => {
      inseamInput.disabled = false;
      inseamInput.parentElement.classList.remove('disabled');
    });

    const selectedWaist = waistInput.value;
    this.defaultSelected.waist = selectedWaist;
    //alert(`waist changed to ${selectedWaist}`);

    // evaluate wich inseams should be disabled

    console.log('products', this.products);

    const variantsWithThisWaist = this.products.map(product => {
      return product.variants.filter(variant => {
        return variant.waist == selectedWaist;
      });
    });

    const inseamsToDisable = [];
    const inseamsExist = [];

    this.inseamOptions.forEach(inseam => {
      variantsWithThisWaist.forEach(product => {
        product.forEach(variant => {
          if (variant.inseam == inseam && !inseamsExist.includes(inseam)) {
            inseamsExist.push(inseam);
          } else if (variant.inseam == inseam && variant.quantity < variant.itemQty) {     // consultar con Cesar si lo valido por exactamente la cantidad de item o al menos le sumo 1 o 2 items
            inseamsToDisable.push(inseam);
          }
        });
      });
    });

    this.inseamOptions.forEach(inseam => {
      if (!inseamsExist.includes(inseam) && !inseamsToDisable.includes(inseam)) {
        inseamsToDisable.push(inseam);
      }
    });

    inseamsToDisable.forEach(inseam => {
      const inseamInput = this.querySelector(`.product-form__input[data-option-name="Inseam"] input[value="${inseam}"]`);
      inseamInput.disabled = true;
      inseamInput.parentElement.classList.add('disabled');
    });
  }

  async setSelectedColorSet(colorSetInput) {

    try {
      this.colorSetSelectedInput = colorSetInput;
      const colorSetInputId = colorSetInput.id;
      const colorSetLabel = document.querySelector(`label[for="${colorSetInputId}"]`);
      const colorSetDescription = colorSetLabel.querySelector('.pack-description');
      const colorSetSizes = colorSetLabel.querySelectorAll('.color-set__sizes');
      this.products = [];

      let dummyTitle = colorSetInput.getAttribute('grand-parent-title');

      colorSetSizes.forEach(colorSetSize => {
        let colorProductObject = {
          variants: [],
          itemQty: colorSetSize.querySelector('.variant__size').getAttribute('item-qty'),
          color: colorSetSize.getAttribute('color')
        };
        const variantsJson = colorSetSize.querySelector('.variants-json');
        const variantsJsonContent = JSON.parse(variantsJson.textContent);
        if (variantsJsonContent) {
          variantsJsonContent.forEach(variantObj => {
            colorProductObject.variants.push(variantObj);
          });
          this.products.push(colorProductObject);
        }
      });

      if (dummyTitle != null) {
        // ".product__title-wrapper .title-type" style=" max-width: 80%; "



      }
      if (colorSetDescription) {
        let packdescription = colorSetDescription.innerHTML;
        let desctab = document.querySelector("alt-description-tab");
        desctab.reInitTabs(packdescription)
      }


      await this.createWaistSelectors(this.products);
      await this.createInseamSelectors(this.products);

      this.setDefaultSelectedWaistAndInseam();
      const selectedWaistSelector = this.querySelector('.product-form__input[data-option-name="Waist"] input:checked');
      const selectedInseamSelector = this.querySelector('.product-form__input[data-option-name="Inseam"] input:checked');
      if (this.defaultSelected.waist && this.defaultSelected.inseam && selectedWaistSelector && selectedInseamSelector) {
        this.selectedWaistValidate(this.defaultSelected.waist);
        this.selectedInseamValidate(this.defaultSelected.inseam);

      }

      this.evaluateInseamAndWaistSelected();

    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  setDomSelectors() {

  }
  /**
   * Evaluate if the waists exist in all the products of the pack , if not dont return the waist
   * 
   * @param {*} products 
   */
  async evaluateWaistsExistingInAllProducts(products) {

    const waists = [];
    products.forEach(product => {
      product.variants.forEach(variant => {
        if (!waists.includes(variant.waist)) {
          waists.push(variant.waist);
        }
      });
    }
    );

    const waistsExistInAllProducts = waists.filter(waist => {
      return products.every(product => {
        return product.variants.some(variant => {
          return variant.waist == waist;
        });
      });
    });
    return waistsExistInAllProducts;

  }
  async createWaistSelectors(products) {

    this.waistOptions = [];
    await this.evaluateWaistsExistingInAllProducts(products).then(waists => {
      this.waistOptions = waists;
    });

    const waistSelector = document.querySelector('.product-form__input[data-option-name="Waist"]');
    console.log(waistSelector);
    waistSelector.innerHTML = '';
    waistSelector.innerHTML += `<legend class="form__label">${window.theme.Waist}: <span class="option-meta-data"></span></legend>`;

    // create a variable to store the inseams that should be disabled per waist , based on the product object if some inseams are not available or doesnt exist for a specific waist in some product

    const inseamOptions = [];
    products.forEach(product => {
      product.variants.forEach(variant => {
        if (!inseamOptions.includes(variant.inseam)) {
          inseamOptions.push(variant.inseam);
        }
      });
    });

    this.waistOptions.forEach((waist, i) => {
      const inputAndLabel = `
      <input type="radio" id="template__main-Waist-${i}" name="Waist" value="${waist}"  class="pack">
      <label for="template__main-Waist-${i}">
        ${waist}
      </label>
      ` 
      waistSelector.innerHTML += inputAndLabel;
    });

    // if there is only one waist, disable the waist selector and set the waist selected default
    if (this.waistOptions.length === 1) {
      const waistInput = this.querySelector(`.product-form__input[data-option-name="Waist"] input[value="${this.waistOptions[0]}"]`);
      waistInput.checked = true;
      this.setSelectedWaist(waistInput);
      const fieldset = waistInput.parentElement;
      fieldset.setAttribute('count', this.waistOptions.length);
      return;
    }

    return;

  }
  async evaluateInseamExistingInAllProducts(products) {
    const inseams = [];
    products.forEach(product => {
      product.variants.forEach(variant => {
        if (!inseams.includes(variant.inseam)) {
          inseams.push(variant.inseam);
        }
      });
    }
    );
    const inseamsExistInAllProducts = inseams.filter(inseam => {
      return products.every(product => {
        return product.variants.some(variant => {
          return variant.inseam == inseam;
        });
      });
    });
    return inseamsExistInAllProducts;
  }

  async createInseamSelectors(products) {
    this.inseamOptions = [];
    await this.evaluateInseamExistingInAllProducts(products).then(inseams => {
      this.inseamOptions = inseams;
    });
    const inseamSelector = document.querySelector('.product-form__input[data-option-name="Inseam"]');
    inseamSelector.innerHTML = '';
    inseamSelector.innerHTML += `<legend class="form__label">${window.theme.inseam_text}: <span class="option-meta-data"></span></legend>`;

    this.inseamOptions.forEach((inseam, i) => {
      const inputAndLabel = `
      <input type="radio" id="template__main-Inseam-${i}" name="Inseam" value="${inseam}"  class="pack">
      <label for="template__main-Inseam-${i}">
        ${inseam}
      </label>
      `
      inseamSelector.innerHTML += inputAndLabel;
    });
    // if there is only one inseam , disable the inseam selector and set the inseam selected default
    if (this.inseamOptions.length === 1) {
      const inseamInput = this.querySelector(`.product-form__input[data-option-name="Inseam"] input[value="${this.inseamOptions[0]}"]`);
      inseamInput.checked = true;
      this.setSelectedInseam(inseamInput);
      const fieldset = inseamInput.parentElement;
      fieldset.setAttribute('count', this.inseamOptions.length);
      return;
    }

    return;


  }
  waistListener() {
    // enable all inseams


    const waistSelector = this.querySelector('.product-form__input[data-option-name="Waist"]');
    waistSelector.addEventListener('change', (e) => {
      const selectedWaist = e.target.value;
      this.selectedWaistValidate(selectedWaist);


    });
  }
  selectedWaistValidate(selectedWaist) {
    const inseamInputs = this.querySelectorAll('.product-form__input[data-option-name="Inseam"] input');
    inseamInputs.forEach(inseamInput => {
      inseamInput.disabled = false;
      inseamInput.parentElement.classList.remove('disabled');
    });

    this.defaultSelected.waist = selectedWaist;

    //alert(`waist changed to ${selectedWaist}`);

    // evaluate wich inseams should be disabled

    console.log('products', this.products);

    const variantsWithThisWaist = this.products.map(product => {
      return product.variants.filter(variant => {
        return variant.waist == selectedWaist;
      });
    });

    const inseamsToDisable = [];
    const inseamsExist = [];
    const packsize = this.packSize;

    this.inseamOptions.forEach(inseam => {
      variantsWithThisWaist.forEach(product => {


        const allVariantsWithThisInseamAndWaist = this.products.map(product => {
          return product.variants.filter(variant => {
            return variant.inseam == inseam && variant.waist == selectedWaist;
          });
        });
        console.log('allVariantsWithThisInseamAndWaist', allVariantsWithThisInseamAndWaist);

        product.forEach(variant => {


          // here I need to veryfy if the variant exist not only on this product , in all the this.products variants of the pack

          const existInAllProducts = this.products.every(product => {
            return product.variants.some(variant => {
              return variant.inseam == inseam && variant.waist == selectedWaist;
            });
          }
          );

          if (variant.inseam == inseam && !inseamsExist.includes(inseam) && variant.quantity > variant.itemQty && existInAllProducts) {
            inseamsExist.push(inseam);
          } else if (variant.inseam == inseam && variant.quantity < variant.itemQty || !existInAllProducts) {     // consultar con Cesar si lo valido por exactamente la cantidad de item o al menos le sumo 1 o 2 items
            inseamsToDisable.push(inseam);
          }
        });
      });
    });

    this.inseamOptions.forEach(inseam => {
      if (!inseamsExist.includes(inseam) && !inseamsToDisable.includes(inseam)) {
        inseamsToDisable.push(inseam);
      }
    });

    inseamsToDisable.forEach(inseam => {
      const inseamInput = this.querySelector(`.product-form__input[data-option-name="Inseam"] input[value="${inseam}"]`);
      inseamInput.disabled = true;
      inseamInput.parentElement.classList.add('disabled');
    });
    this.evaluateInseamAndWaistSelected();
  }
  inseamListener() {
    // same that waist listener but with inseam
    const inseamSelector = this.querySelector('.product-form__input[data-option-name="Inseam"]');

    inseamSelector.addEventListener('change', (e) => {

      const selectedInseam = e.target.value;
      this.selectedInseamValidate(selectedInseam);

    });

  }
  selectedInseamValidate(selectedInseam) {
    const waistInputs = this.querySelectorAll('.product-form__input[data-option-name="Waist"] input');
    waistInputs.forEach(waistInput => {
      waistInput.disabled = false;
      waistInput.parentElement.classList.remove('disabled');
    });


    this.defaultSelected.inseam = selectedInseam;
    //alert(`inseam changed to ${selectedInseam}`);

    // evaluate wich inseams should be disabled

    console.log('products', this.products);

    const variantsWithThisInseam = this.products.map(product => {
      return product.variants.filter(variant => {
        return variant.inseam == selectedInseam;
      });
    });

    const waistsToDisable = [];
    const waistsExist = [];

    this.waistOptions.forEach(waist => {
      variantsWithThisInseam.forEach(product => {
        product.forEach(variant => {
          const existInAllProducts = this.products.every(product => {
            return product.variants.some(variant => {
              return variant.waist == waist && variant.inseam == selectedInseam;
            });
          }
          );
          if (variant.waist == waist && !waistsExist.includes(waist) && variant.quantity > variant.itemQty && existInAllProducts) {
            waistsExist.push(waist);
          } else if (variant.waist == waist && variant.quantity < variant.itemQty && !existInAllProducts) {     // consultar con Cesar si lo valido por exactamente la cantidad de item o al menos le sumo 1 o 2 items
            waistsToDisable.push(waist);
          }
        });
      });
    });

    this.waistOptions.forEach(waist => {
      if (!waistsExist.includes(waist) && !waistsToDisable.includes(waist)) {
        waistsToDisable.push(waist);
      }
    });

    waistsToDisable.forEach(waist => {
      const waistInput = this.querySelector(`.product-form__input[data-option-name="Waist"] input[value="${waist}"]`);
      waistInput.disabled = true;
      waistInput.parentElement.classList.add('disabled');
    });
    this.evaluateInseamAndWaistSelected();
  }

  evaluateInseamAndWaistSelected() {


    const waistSelector = this.querySelector('.product-form__input[data-option-name="Waist"]');
    const inseamSelector = this.querySelector('.product-form__input[data-option-name="Inseam"]');

    const waistSelected = waistSelector.querySelector('input:checked');
    const inseamSelected = inseamSelector.querySelector('input:checked');



    if (waistSelected && inseamSelected && !waistSelected.disabled && !inseamSelected.disabled) {
      this.variants_IDs = [];
      // add the dom elements to the related with the selected waist and inseam there are elements that makes reference and has the info into the .color_picker-colors-container checked input

      const waist = waistSelected.value;
      const inseam = inseamSelected.value;
      const selectedFit = document.querySelector(".product-fit__choice.fit-active").getAttribute("data-fit");
      console.log('fit', selectedFit);
      const colorSetWrapper = document.querySelector(`.color-set__wrapper.color_picker-colors[pack-size="${this.packSize}"][fit="${selectedFit}"]`);
      console.log('colorSetWrapper', colorSetWrapper);
      const colorSetLabel = colorSetWrapper.querySelector(`label[for="${this.colorSetSelectedInput.id}"]`);

      this.productPack.variants_IDs = colorSetLabel.querySelectorAll(`.color-set__sizes .variant__size[waist="${waist}"][inseam="${inseam}"]`);

      if (this.productPack.variants_IDs.length > 0) {
        this.atcBtn.classList.remove('disabled-error');
        this.atcBtn.classList.remove('disabled');
      }

      this.productPack.changePrice();

    } else {
      this.atcBtn.classList.add('disabled-error');
    }
  }

}
customElements.define("jean-pack-size", JeanPackSize);